import { ApiClient } from '@webapp/core/services/ApiClient'
import { UserRepository } from '@webapp/platform/iam/data-access/repositories/UserRepository/UserRepository'

export const userRepository = new UserRepository({
  httpClient: ApiClient,
})
